module.exports = __webpack_public_path__ + "static/media/Loss Aversion.fba132ec.jpg";